import { renderSprite } from 'js/sprite'
import searchBox from 'js/components/search/searchBox'
import homeIntroSlider from 'js/components/homeIntroSlider/HomeIntroSlider'
import searchBoxHomeWithFilters from 'js/components/searchHomepageWithFilters/searchBox'
import initMainSearchBox from 'js/scenes/MainSearchBox'
import { renderHeaderBlock } from 'js/subHeader'
import renderAnchorScroll from 'js/anchorScroll'
import { renderDestinationsPushSlider } from 'js/destinationsPushSlider'
import { renderLazyLoadGoogleMaps } from 'js/lazyGoogleMap'
import { renderSimplePopup } from 'js/simplePopup'
import { fontLoadObserver } from 'js/fontsLoad'
import renderMegaMenu from 'js/components/megaMenu/MegaMenu'
import { cleanOneTrustHtags } from 'js/cleanOneTrustHtags'
// import { renderCookieBanner } from './js/cookieBanner'
// import { renderLoginErrorPopup } from './js/loginErrorPopup'

import 'js/trusted-security-policies'
import 'js/polyfils'
import 'js/footer'
import 'js/handlers'
import 'js/components/gmap/hotelMap'
import './index.scss'
import 'js/adBlockerPopin'
import 'js/toggleText'
import 'js/informationBanner'
import 'js/becomeMemberExt'

// Search/filters header react components
window.renderSearchBox = searchBox
window.renderSearchHomepageWithFilters = searchBoxHomeWithFilters

// window.renderHomeBanner = homeBanner
window.renderHomeIntroSlider = homeIntroSlider

// Try to load lazy
window.renderLazyLoadGoogleMaps = renderLazyLoadGoogleMaps
window.renderSimplePopup = renderSimplePopup
window.renderDestinationsPushSlider = renderDestinationsPushSlider
// window.renderCookieBanner = renderCookieBanner // Seems not used in site
// window.renderLoginErrorPopup = renderLoginErrorPopup // Seems not used in site

// Used for every page
window.cleanOneTrustHtags = cleanOneTrustHtags
window.renderMegaMenu = renderMegaMenu
window.renderHeaderBlock = renderHeaderBlock
window.fontLoadObserver = fontLoadObserver
window.renderSprite = renderSprite
window.renderAnchorScroll = renderAnchorScroll
window.initMainSearchBox = initMainSearchBox
